module.exports = __webpack_public_path__ + "static/media/visaFC.32d6fe07.png";